import { OrderAvailableActionTypes, OrderAvailableTypes } from '../actions/order-availability.actions';

export interface OrderAvailabilityState {
  create: boolean;
}

export const initialState: OrderAvailabilityState = {
  create: true,
};

export function reducer(state = initialState, action: OrderAvailableTypes): OrderAvailabilityState {
  switch (action.type) {
    case OrderAvailableActionTypes.ORDER_AVAILABLE: {
      return {
        ...state,
        create: action.payload,
      } as OrderAvailabilityState;
    }
    case OrderAvailableActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
